// extracted by mini-css-extract-plugin
export var dateWrapper = "UpcomingEvent-module--dateWrapper--48740";
export var day = "UpcomingEvent-module--day--b216b";
export var month = "UpcomingEvent-module--month--63481";
export var small = "UpcomingEvent-module--small--680f0";
export var text = "UpcomingEvent-module--text--b329d";
export var whiteBg = "UpcomingEvent-module--whiteBg--72106";
export var wrapper = "UpcomingEvent-module--wrapper--11df4";